import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TrunkSearchQuery } from '../../../../../components/common/TrunkSeachQuery';
import styles from './SearchSubtitle.scss';
import { ISearchSubtitleOuter } from '../../EmptyState.types';
import classNames from 'classnames';

export const SearchSubtitle: FC<ISearchSubtitleOuter> = ({ searchQuery }) => {
  return (
    <TrunkSearchQuery searchQuery={searchQuery} wrapperClassName={styles.searchSubtitle}>
      {({ searchQuery }) => <FormattedMessage id="empty-state.search-subtitle" values={{ searchQuery }} />}
    </TrunkSearchQuery>
  );
};

export const NewSearchSubtitle: FC<ISearchSubtitleOuter> = () => (
  <span className={classNames(styles.searchSubtitle, styles.subtitleNewBrandingStyles)}>
    <FormattedMessage id="empty-state.search-subtitle-new" />
  </span>
);
